<script setup lang="ts">
import { useLexicalComposer } from "lexical-vue";

import RecommendationActionButtons from "~/components/dumb/RecommendationActionButtons.vue";
import { RecommendationAction } from "~/shared/enums";

import { EVENT_CLEANUP_RECOMMENDATION_NODE } from "../const";

const props = defineProps<{
  nodeKey?: string;
  recommendationDuid?: string;
}>();

const emit = defineEmits<{
  action: [action: RecommendationAction];
}>();

const editor = useLexicalComposer();

const onAction = (action: RecommendationAction) => {
  if (!props.nodeKey) {
    emit("action", action);
    return;
  }
  editor.dispatchCommand(EVENT_CLEANUP_RECOMMENDATION_NODE, {
    key: props.nodeKey,
    action,
    recommendationDuid: props.recommendationDuid,
  });
};
</script>

<template>
  <RecommendationActionButtons
    insert-tooltip-text="Add this AI-generated content to the description"
    replace-tooltip-text="Replace the original description with this AI-generated content"
    class="py-2"
    @insert="onAction(RecommendationAction.KEEP)"
    @replace="onAction(RecommendationAction.REPLACE)" />
</template>
